import React from 'react';
import BannerCarousel from '../MobileComponents/BannerCarousel';
import PreferenceCards from '../MobileComponents/PreferenceCards';
import SingleBanner from '../MobileComponents/SingleBanner';
import Description from '../MobileComponents/Description';
import Focus from '../MobileComponents/Focus';
import Colapse from '../MobileComponents/Colapse';
import RedirectMenu from '../MobileComponents/RedirectMenu';
import MediaYoutube from '../MobileComponents/MediaYoutube';
import Topic from '../MobileComponents/Topic';
import Card from '../MobileComponents/Card';
import ProductTable from '../MobileComponents/ProductTable';
import InfiniteScroll from '../MobileComponents/InfiniteScroll';
import UniqueProduct from '../MobileComponents/UniqueProduct';
import ProductCarouselQuery from '../MobileComponents/ProductCarouselQuery';
import VtexCollectionPhone from '../MobileComponents/VtexCollection';
import ProductsCarousel from '../MobileComponents/ProductsCarousel';
import RedirectTitle from '../MobileComponents/RedirectTitle';
import HighlightFilter from '../MobileComponents/HighlightFilter';
import BannersCols from '../MobileComponents/BannersCols';
import BannersMosaic from '../MobileComponents/BannersMosaic';
import CarouselStories from '../MobileComponents/CarouselStories';
import PromotionalBannersCarousel from '../MobileComponents/PromotionalBannerCarousel';
import InsiderCampaignPhone from '../MobileComponents/InsiderCampaignPhone';
import SalesforceShowcasePhone from '../MobileComponents/SalesforceShowcasePhone';
import SalesforceBannersPhone from '../MobileComponents/SalesforceBannersPhone';
import SalesforceStoriesPhone from '../MobileComponents/SalesforceStoriesPhone';
import LinxProductsPhone from '../MobileComponents/LinxProductsPhone';
import BannersGrid from '../MobileComponents/BannersGrid';
import VitrineComBanner from '../MobileComponents/VitrineComBanner';
import VitrineComCronometro from '../MobileComponents/VitrineComCronometro';
// import MosaicBannerCarouselVertical from '../MobileComponents/MosaicBannerCarouselVertical';
// import MosaicBannerCarousel from '../MobileComponents/MosaicBannerCarousel';

const components: { [key: string]: React.FC<any> } = {
  'banner-unico': SingleBanner,
  // 'banners-col': BannersCols,
  'banners-em-coluna': BannersCols,
  'banners-em-colunas': BannersCols,
  // 'banners-mosaic': BannersMosaic,
  'mosaico-de-banners': BannersMosaic,
  'carrossel-de-stories': CarouselStories,
  'carrossel-de-banner': BannerCarousel,
  'banners-em-grid': BannersGrid,
  'vitrine-com-banner': VitrineComBanner,
  'vitrine-com-cronometro': VitrineComCronometro,
  'cards-de-preferencias': PreferenceCards,
  'carrosel-de-banner-promocional': PromotionalBannersCarousel,
  'carrossel-de-produtos': ProductsCarousel,
  'carrossel-de-produtos-query': ProductCarouselQuery,
  // 'banner-unico-countdown': SingleBanner,
  // 'carrossel-de-banner-mosaico': MosaicBannerCarousel,
  // 'carrossel-de-banner-mosaico-vertical': MosaicBannerCarouselVertical,
  // description: Description,
  'texto-de-descricao': Description,
  // 'redirect-title': RedirectTitle,
  'titulo-com-redirecionamento': RedirectTitle,
  // focus: Focus,
  'texto-de-foco': Focus,
  // colapse: Colapse,
  colapsavel: Colapse,
  // 'redirect-menu': RedirectMenu,
  'links-redirecionaveis': RedirectMenu,
  // 'highlight-filter': HighlightFilter,
  'filtro-destaque': HighlightFilter,
  'colecao-vtex': VtexCollectionPhone,
  'media-youtube': MediaYoutube,
  // topic: Topic,
  topicos: Topic,
  // card: Card,
  'card-de-topicos': Card,
  // 'table-products': ProductTable,
  'tabela-de-produtos': ProductTable,
  // 'infinite-scroll': InfiniteScroll,
  'scroll-infinito': InfiniteScroll,
  // 'unique-product': UniqueProduct,
  'produto-unico': UniqueProduct,
  'campanha-insider': InsiderCampaignPhone,
  'vitrine-salesforce': SalesforceShowcasePhone,
  'banners-salesforce': SalesforceBannersPhone,
  'stories-salesforce': SalesforceStoriesPhone,
  'vitrine-linx': LinxProductsPhone,
};

export default components;
